/**
 * A MUI Dialog rendered as the onboarding card: dark page ground, the card
 * paper, and the scoped onboarding theme so every input, menu and button
 * inside (portals included) picks up the dark palette.
 */
import React from 'react';
import { Dialog, DialogProps } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { onboardingBackdropSx, onboardingPaperSx, onboardingSurfaceSx, onboardingTheme } from './onboardingTheme';
import { MOBILE_SX, useIsMobileApp } from '../../../mobile/mobileApp';

/** Phone: the step's fields and buttons sit on the app's 16px gutter. */
const phonePaperSx = {
  [MOBILE_SX]: {
    '& > .MuiDialogContent-root': { px: 2 },
    '& > .MuiDialogActions-root': { px: 2, pb: 2 }
  }
};

const OnboardingDialog: React.FC<DialogProps> = ({ children, PaperProps, BackdropProps, fullScreen, ...rest }) => {
  // Callers ask for full screen below 600px; the phone shell's breakpoint is wider, so it applies up to there too.
  const isMobileApp = useIsMobileApp();
  const paperSx = PaperProps?.sx;
  const extraPaperSx = Array.isArray(paperSx) ? paperSx : paperSx ? [paperSx] : [];
  const backdropSx = BackdropProps?.sx;
  const extraBackdropSx = Array.isArray(backdropSx) ? backdropSx : backdropSx ? [backdropSx] : [];
  return (
    <ThemeProvider theme={onboardingTheme}>
      <Dialog
        fullWidth
        {...rest}
        fullScreen={fullScreen || isMobileApp}
        BackdropProps={{ ...BackdropProps, sx: [onboardingBackdropSx, ...extraBackdropSx] }}
        PaperProps={{ ...PaperProps, sx: [onboardingPaperSx, onboardingSurfaceSx, phonePaperSx, ...extraPaperSx] }}
      >
        {children}
      </Dialog>
    </ThemeProvider>
  );
};

export default OnboardingDialog;
